import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Alert,
  CircularProgress,
} from '@mui/material';
import RestaurantIcon from '@mui/icons-material/Restaurant';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

interface ConfirmOpenTableModalProps {
  open: boolean;
  tableName: string;
  productName: string;
  waiterName: string;
  onConfirm: () => void;
  onCancel: () => void;
  isLoading?: boolean; // ✅ YENİ: Loading state
}

const ConfirmOpenTableModal: React.FC<ConfirmOpenTableModalProps> = ({
  open,
  tableName,
  productName,
  waiterName,
  onConfirm,
  onCancel,
  isLoading = false, // ✅ YENİ: Loading state
}) => {
  return (
    <Dialog
      open={open}
      onClose={isLoading ? undefined : onCancel} // ✅ Loading sırasında kapatmayı engelle
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          boxShadow: 24,
        },
      }}
    >
      <DialogTitle
        sx={{
          bgcolor: 'warning.main',
          color: 'white',
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          py: 2,
        }}
      >
        <WarningAmberIcon />
        <Typography variant="h6" component="div">
          Adisyon Açma Onayı
        </Typography>
      </DialogTitle>

      <DialogContent sx={{ mt: 3 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Alert severity="info" icon={<RestaurantIcon />}>
            Yeni bir adisyon açmak üzeresiniz.
          </Alert>

          <Box
            sx={{
              p: 2,
              bgcolor: 'background.default',
              borderRadius: 1,
              border: '1px solid',
              borderColor: 'divider',
            }}
          >
            <Typography variant="body1" gutterBottom>
              <strong>Masa:</strong> {tableName}
            </Typography>
            <Typography variant="body1" gutterBottom>
              <strong>Garson:</strong> {waiterName}
            </Typography>
            <Typography variant="body1" gutterBottom>
              <strong>İlk Ürün:</strong> {productName}
            </Typography>
          </Box>

          <Typography variant="body2" color="text.secondary" align="center">
            Adisyonu açmak istediğinizden emin misiniz?
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions sx={{ px: 3, py: 2, gap: 1 }}>
        <Button
          onClick={onCancel}
          variant="outlined"
          color="inherit"
          size="large"
          sx={{ minWidth: 120 }}
          disabled={isLoading} // ✅ Loading sırasında disable
        >
          İptal
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color="success"
          size="large"
          autoFocus
          sx={{ minWidth: 120 }}
          disabled={isLoading} // ✅ Loading sırasında disable
          startIcon={isLoading ? <CircularProgress size={20} color="inherit" /> : null} // ✅ Loading göstergesi
        >
          {isLoading ? 'Açılıyor...' : 'Onay'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmOpenTableModal;

